export default "__VITE_ASSET__BOv1ihs3__"